// addUploadJob.js
'use strict';
import { MERGE_OPERATION_DATA, ADD_LIST_ITEMS } from '../ActionTypes.js';

import processUploadJob from '../action/processUploadJob.js';

import {
  Entry as UploadEntry,
  Priority as UploadPriority,
  Status as UploadStatus,
} from '../resource/uploadConstants.js';

/**
 * Add upload job
 * @kind action
 * @param {string} {uploadJobId} - upload job id.
 * @param {UploadEntry} {type} - upload type.
 * @param {array} {assetIds} - asset ids.
 * @param {string} {messageId} - local message id.
 * @return {Promise} Action promise.
 */
const addUploadJob =
  ({ uploadJobId, type, assetIds, messageId } = {}) =>
  async dispatch => {
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['uploadJob', uploadJobId],
        data: {
          id: uploadJobId,
          type,
          status:
            // update status to upload.completed since clip's asset already uploaded to server.
            UploadEntry.CLIP === type
              ? UploadStatus.UPLOAD_COMPLETED
              : UploadStatus.PENDING,
          reason: undefined,
          priority: UploadPriority[type],
          assetIds,
          messageId,
        },
      },
    });
    dispatch({
      type: ADD_LIST_ITEMS,
      payload: {
        selectPath: ['uploadJob'],
        itemIds: [uploadJobId],
      },
    });
    switch (type) {
      case UploadEntry.ME:
      case UploadEntry.STORY:
      case UploadEntry.POST:
      case UploadEntry.KYC:
      case UploadEntry.CLIP:
      case UploadEntry.CHAT:
      case UploadEntry.REPLY: {
        return dispatch(processUploadJob());
      }
      default: {
        return dispatch({ type: '' });
      }
    }
  };

export default addUploadJob;
